import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  email,
  minValue,
  ImageInput,
  ReferenceInput,
  AutocompleteInput,
  DateInput,
  SelectInput,
} from 'react-admin'
import Grid from '@mui/material/Grid'

import { validateRequired } from '../../utils/validate'
import CustomImageField from '../../components/CustomImageField'
import GridContainer from '../../components/GridContainer'

const AffiliateCreate = props => {
  return (
    <Create redirect="list" {...props}>
      <SimpleForm>
        <GridContainer>
          <Grid item xs={12}>
            <TextInput
              label="Name"
              source="name"
              fullWidth
              validate={validateRequired('Name')}
              variant="standard"
            />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              label="Email Address"
              source="email"
              type="email"
              fullWidth
              validate={email()}
              variant="standard"
            />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              label="Url slug"
              source="slug"
              fullWidth
              variant="standard"
            />
          </Grid>

          <Grid item xs={6}>
            <DateInput
              label="Start date"
              source="startAt"
              fullWidth
              variant="standard"
            />
          </Grid>

          <Grid item xs={6}>
            <DateInput
              label="Expire date"
              source="expireAt"
              fullWidth
              variant="standard"
            />
          </Grid>

          <Grid item xs={12}>
            <ImageInput
              source="picture"
              label="Picture (recommend size: 300x300)"
              accept="image/*"
              multiple={false}>
              <CustomImageField source="src" title="Picture" />
            </ImageInput>
          </Grid>

          <Grid item xs={12}>
            <TextInput
              source="quote"
              resettable
              rows={5}
              fullWidth
              validate={[validateRequired('Quote')]}
              multiline
              variant="standard"
            />
          </Grid>

          <Grid item xs={6}>
            <NumberInput
              label="Quantity Limit"
              source="quantityLimit"
              fullWidth
              options={{
                fullWidth: true,
              }}
              validate={minValue(0)}
              variant="standard"
            />
          </Grid>

          <Grid item xs={6}>
            <SelectInput
              label="Is commission included?"
              source="commissionIncluded"
              choices={[
                { id: true, name: 'True' },
                { id: false, name: 'False' },
              ]}
              fullWidth
              required
              variant="standard"
              defaultValue={false}
            />
          </Grid>

          <Grid item xs={12}>
            <ReferenceInput
              variant="standard"
              label="Book"
              source="bookId"
              reference="books">
              <AutocompleteInput
                optionText="title"
                options={{
                  fullWidth: true,
                }}
                filterToQuery={searchText => ({
                  title: { $iLike: `%${searchText}%` },
                })}
              />
            </ReferenceInput>
          </Grid>
        </GridContainer>
      </SimpleForm>
    </Create>
  )
}

export default AffiliateCreate
